import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EntryNotFoundException } from '@web/common';
import { isNil } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { BoxQuestionnaireSelectType } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class BoxQuestionnaireSelectTypeProviderService {
  private readonly entries = new Map<BoxQuestionnaireSelectType, string>([
    [BoxQuestionnaireSelectType.ByUser, 'Wybór użytkownika'],
    [BoxQuestionnaireSelectType.BySystem, 'Wybór automatyczny'],
  ]);

  public labelFor(selectType: BoxQuestionnaireSelectType): Observable<string> {
    const result = this.entries.get(selectType);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${selectType}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<BoxQuestionnaireSelectType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) =>
          new SelectItem<BoxQuestionnaireSelectType>(label, status),
      ),
    );
  }
}
